import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AdminGuard, AuthGuard} from './shared/guard';
import {LayoutComponent} from './layout/layout.component';
import {LayoutModule} from './layout/layout.module';
import { InternetExplorerMsgComponent } from './internet-explorer-msg/internet-explorer-msg.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordModule } from './reset-password/reset-password.module';
import { CoachResetPasswordComponent } from './coach-reset-password/coach-reset-password.component';
import { CoachResetPasswordModule } from './coach-reset-password/coach-reset-password.module';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                data: { title: 'Dashboard' },
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'create-access',
                data: { title: 'Zugang erstellen' },
                loadChildren: './access-code/access-code.module#AccessCodeModule'
            },
            {
                path: 'patient',
                data: { title: 'Patient' },
                loadChildren: './patient/patient.module#PatientModule'
            },
            {
                path: 'admin',
                data: { title: 'Administration' },
                loadChildren: './admin/admin.module#AdminModule'
            },
            {
                path: 'clinics',
                data: { title: 'Kliniken' },
                loadChildren: './clinics/clinics.module#ClinicsModule'
            },
            {
                path: 'settings',
                data: { title: 'Einstellungen' },
                loadChildren: './settings/settings.module#SettingsModule',
            },
            {
                path: 'information',
                data: { title: 'Information' },
                loadChildren: './information/information.module#InformationModule'
            },
            {
                path: 'stats',
                data: { title: 'Statistik' },
                loadChildren: './stats/stats.module#StatsModule',
                canActivate: []
            },
            {
                path: 'export',
                data: { title: 'Export' },
                loadChildren: './export/export.module#ExportModule',
                canActivate: []
            },
            {
                path: 'push-notifications',
                data: { title: 'Push-Benachrichtigungen' },
                loadChildren: './push-notifications/push-notifications.module#PushNotificationsModule',
                canActivate: []
            }
        ]
    },
    {
        path: 'print/patient',
        loadChildren: './patient/patient.module#PatientModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'print/access-code',
        loadChildren: './access-code/access-code.module#AccessCodeModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'login',
        data: { title: 'Login' },
        loadChildren: './login/login.module#LoginModule'
    },
    {
        path: 'internet-explorer-msg',
        component: InternetExplorerMsgComponent
    },
    {
        path: 'reset-password',
        pathMatch: 'prefix',
        component: ResetPasswordComponent
        // loadChildren: () => import('./reset-password/reset-password.module').then(mod => mod.ResetPasswordModule)
    },
    {
        path: 'coach-reset-password',
        component: CoachResetPasswordComponent
    }
];

@NgModule({
    imports: [
        LayoutModule,
        ResetPasswordModule,
        CoachResetPasswordModule,
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule],
    providers: [AuthGuard]
})
export class AppRoutingModule {}
